import * as React from "react";

import { ACountry, useLocalizationProvider } from "../../Common";

export const Header: React.FunctionComponent = () => {
  const { countryCode } = useLocalizationProvider();

  const subtitle = React.useMemo(() => {
    switch (countryCode) {
      case ACountry.Australia:
        return "Our e-gift cards can be redeemed online and in-store at all Australian locations.";
      case ACountry.NewZealand:
        return "Our e-gift cards can be redeemed online and in-store at all New Zealand locations.";
      default:
        return null;
    }
  }, [countryCode]);

  return (
    <div className="header">
      <div className="background-overlay" />
      <div className="title-container">
        <h1 className="title">E-Gift Cards</h1>
        <p className="subtitle">{subtitle}</p>
      </div>
    </div>
  );
};
